/**
 * Servicio de gestión de credenciales de la VPN
 */

import axios from 'axios'
import API from '@/API.js'
import md5 from 'md5'

const apiClient = axios.create({
  baseURL: `${API}/vpn/credenciales`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(credencial) {
    return apiClient.patch(`${credencial.id}`, credencial)
  },

  cantidadTotal() {
    return apiClient.get('cantidad-total')
  },

  guardar(credencial) {
    return apiClient.post('', credencial)
  },

  eliminar(idCredencial) {
    return apiClient.delete(`${idCredencial}`)
  },

  credencialJSON(id) {
    return apiClient.get(`${id}.json`)
  },

  credencialesJSON(params) {
    return apiClient.get(`${API}/vpn/credenciales.json`, { params: params })
  }
}
